import { useState } from "react";
import { showToast } from "../toastService";
import { apiFetch } from "../utils/api";
import { USER_BASE_URL, VERSION } from "../utils/config";
import Navbar from "../components/Navbar";
import Lottie from "lottie-react";
import successAnimation from "../assets/lottie/success.json"; // <-- adjust path
import "../styles/ProfileComplete.css";

export default function ProfileComplete() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [touched, setTouched] = useState(false);
  const [emailTouched, setEmailTouched] = useState(false);
  const [throwError, setThrowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const validateInputs = () => {
    const trimmedName = name.trim();
    const trimmedEmail = email.trim();

    // ✅ Name: only letters + spaces, 1–100 chars
    const nameRegex = /^[A-Za-z ]+$/;
    if (
      trimmedName.length < 1 ||
      trimmedName.length > 100 ||
      !nameRegex.test(trimmedName)
    ) {
      // showToast(
      //   "Name must be 1–100 characters and contain only letters and spaces.",
      //   "error"
      // );
      setThrowError(true)
      return false;
    }

    // ✅ Email: valid format, 5–255 chars
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (
      trimmedEmail.length < 5 ||
      trimmedEmail.length > 255 ||
      !emailRegex.test(trimmedEmail)
    ) {
      // showToast("Please enter a valid email address (5–255 characters).", "error");
      setThrowError(true)
      return false;
    }

    return true;
  };

  // ✅ Name Validator
  // Rules:
  //   • Only letters (a–z, A–Z) and spaces
  //   • Length between 1 and 100 characters
  function validateName(name) {
    const trimmed = name.trim();
    if (trimmed.length < 1 || trimmed.length > 100) return false;
    const nameRegex = /^[A-Za-z ]+$/;
    return nameRegex.test(trimmed);
  }

  // ✅ Email Validator
  // Rules:
  //   • Valid email pattern
  //   • Length between 5 and 255 characters
  function validateEmail(email) {
    const trimmed = email.trim();
    if (trimmed.length < 5 || trimmed.length > 255) return false;
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(trimmed);
  }

  const handleSubmit = async () => {
    setThrowError(false)
    if (!validateInputs()) return;

    setLoading(true);
    try {
      const data = await apiFetch(
        `${USER_BASE_URL}/${VERSION}/profile/web/complete`,
        "POST",
        JSON.stringify({ name: name.trim(), email: email.trim() }),
        { "Content-Type": "application/json" }
      );
      setLoading(false);
      if (data) {
        if(data && data.name ){
          localStorage.setItem("username", data.name)
        };
        setSuccess(true);
        setTimeout(() => window.location.reload(), 2000);
      } else {
        showToast("Failed to complete profile. Try again.", "error");
      }
    } catch (err) {
      console.error(err);
      if (err.type === "version_reloading") return;
      setLoading(false);
      showToast(err.message, "error");
    }
  };

  if (success) {
    return (
      <div className="pc-wrapper-2">
        <Navbar />
        <div className="confetti">
          <Lottie
            animationData={successAnimation}
            loop={false}
            autoplay
            style={{ width: 200, height: 200 }} // Adjust size as needed
          />
        </div>
        <h2 className="pc-title">🎉 Profile completed successfully!</h2>
      </div>
    );
  }

  return (
    <div className="pc-wrapper">
      <Navbar />

      <h2 className="pc-heading">Create your account</h2>
      <p className="pc-subtitle">Please provide your name and email to continue.</p>

      <form className="pc-form">
        <p className="form-field-title">Enter your fullname</p>
        <div className="input-field-div">
          <input
            type="text"
            placeholder="Name"
            maxLength={100}
            className="pc-input"
            value={name}
            onChange={(e) => {
              const value = e.target.value;

              // Remove non-letters/spaces, then collapse consecutive spaces
              const cleaned = value.replace(/[^a-zA-Z\s]/g, "").replace(/\s{2,}/g, " ");

              setName(cleaned);
              if (!touched) setTouched(true);
            }}
          />
          { (touched || throwError) && !validateName(name) ? <div className="error">Please input correct name to proceed</div> : ''}
        </div>
        <p className="form-field-title">Enter your email address</p>
        <div className="input-field-div">
          <input
            type="email"
            placeholder="Email"
            maxLength={255}
            className="pc-input"
            value={email}
            onChange={(e) => {
              const value = e.target.value;

              // Allow only common email characters
              const cleaned = value.replace(/[^a-zA-Z0-9@._+-]/g, "");

              setEmail(cleaned);

              if (!emailTouched) setEmailTouched(true); // if tracking touched state
            }}
          />
          { (emailTouched || throwError) && !validateEmail(email) ? <div className="error">Please input correct email to proceed</div> : ''}
        </div>
      </form>
      <button onClick={handleSubmit} type="submit" className="verify-btn" disabled={loading}>
        {loading ? <span className="loader"></span> : "Continue"}
      </button>
    </div>
  );
}